var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9463 38.7889C66.4749 44.7135 64.3128 50.3783 60.7165 55.1101C57.1203 59.8421 52.2416 63.4422 46.6594 65.4825C41.0774 67.5232 35.0269 67.9187 29.2268 66.622C23.4268 65.3249 18.1208 62.3906 13.9395 58.1667C9.75809 53.9434 6.87701 48.6081 5.63853 42.7953C4.40005 36.9824 4.85621 30.9363 6.95284 25.3751C9.04948 19.8139 12.6984 14.9714 17.4662 11.423C22.234 7.87455 27.9201 5.76932 33.8491 5.35742",
    stroke: "#212529",
    strokeWidth: 3.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3255 41.5323C48.4631 43.7522 47.0609 45.722 45.2458 47.2637C43.4307 48.8055 41.26 49.8704 38.9298 50.3624C36.5997 50.8542 34.1837 50.7577 31.9003 50.0812C29.617 49.4046 27.5382 48.1697 25.852 46.4879C24.1659 44.8061 22.9256 42.7305 22.2432 40.4489C21.5609 38.1673 21.458 35.7515 21.9439 33.4201C22.4298 31.0887 23.4892 28.9152 25.0263 27.0962C26.5633 25.2771 28.5296 23.8699 30.7471 23.0017",
    stroke: "#212529",
    strokeWidth: 3.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36.3266L47.9398 24.3867",
    stroke: "#0593A1",
    strokeWidth: 3.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4926 26.7749L47.9407 24.3869L45.5527 14.8351L55.1046 5.2832L57.4926 14.8351L67.0444 17.223L57.4926 26.7749Z",
    stroke: "#0593A1",
    strokeWidth: 4.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon);
export default __webpack_public_path__ + "static/media/mission_icon.d6b6938623cacf362aa0e466b5834bd5.svg";
export { ForwardRef as ReactComponent };